import {userService} from '../services/user.services';

export const fetchUserData = (data ) => dispatch => {

    let userData = userService.getAllUsers(data);
    userData.then(userData => {
        dispatch({
            type: "USER_DATA_SUCCESS",
            userData
        });
    });
}
export const searchUser = ( data ) => dispatch => {

    let filteredData = data.userListData;
    let searchvalue = data.search_text;
    if(searchvalue !== '') {
        filteredData = filteredData.filter(
            item => (item.name!== null)?(item.name.toLowerCase().search(searchvalue.toLowerCase()) >= 0):''
        )
    }

    if(data.sort === 'new') {
        filteredData.sort(function(a, b){
            return b.id-a.id
        });
    }
    else if(data.sort === 'old') {
        filteredData.sort(function(a, b){
            return a.id-b.id
        });
    }
    else if(data.sort === 'az') {
        filteredData.sort(function(a, b){
            if(a.name !== undefined && b.name !== undefined && a.name !== null && b.name !== null) {
                var nameA=a.name.toLowerCase(), nameB=b.name.toLowerCase()
                if (nameA < nameB) //sort string ascending
                    return -1
                if (nameA > nameB)
                    return 1
            }
            else
                return 0 //default return value (no sorting)
        });
    }
    else if(data.sort === 'za') {
        filteredData.sort(function(a, b){
            if(a.name !== undefined && b.name !== undefined && a.name !== null && b.name !== null) {
                var nameA=a.name.toLowerCase(), nameB=b.name.toLowerCase()
                if (nameA > nameB) //sort string ascending
                    return -1
                if (nameA < nameB)
                    return 1
            }
            else
                return 0 //default return value (no sorting)
        });
    }

    dispatch({
        type: "USER_DATA_SEARCH_SUCCESS",
        filteredData : filteredData,
        searchText : data.search_text,
        sort : data.sort,
        userid : data.userid

    });
}
export const createUser = (data ) => dispatch => {

    let created = userService.createUser(data);

    created.then(created => {
        dispatch({
            type: "CREATE_USER",
            created
        });
    });
}
export const passwordUpdate = (data ) => dispatch => {
    let passwordUpdate = userService.passwordUpdate(data);
    passwordUpdate.then(passwordUpdate => {
        dispatch({
            type: "PASSWORD_UPDATE",
            passwordUpdate
        });
    });
}

export const checkExistingUser = (data ) => dispatch => {

    let userExists = userService.checkExistingUser(data);

    userExists.then(userExists => {
        dispatch({
            type: "EXIST_USER_EMAIL",
            userExists
        });
    });
}

export const checkExistingEmail = (data ) => dispatch => {

    let emailExists = userService.checkExistingEmail(data);

    emailExists.then(emailExists => {
        dispatch({
            type: "EXIST_EMAIL",
            emailExists
        });
    });
}
export const showUserModal = ( ) => dispatch => {

    dispatch({
        type: "SHOW_USER_MODAL"
    });
}
export const newUser = (state ) => dispatch => {

    dispatch({
        type: "NEW_USER",
        state
    });
}
export const editUser = (data ) => dispatch => {

    dispatch({
        type: "EDIT_USER",
        userIndex : data.userIndex
    });
}
export const editProfile = (state ) => dispatch => {

    dispatch({
        type: "EDIT_PROFILE",
        state
    });
}
export const getUser = (data ) => dispatch => {

    let currentUser = userService.getUser(data);

    currentUser.then(currentUser => {
        dispatch({
            type: "GET_USER",
            currentUser
        });
    });
}
export const updateProfile = (data ) => dispatch => {

    let updated = userService.updateProfile(data);

    updated.then(updated => {
        dispatch({
            type: "UPDATE_USER_PROFILE",
            updated
        });
    });
}
export const searchIndex = (state ) => dispatch => {

    dispatch({
        type: "UPDATE_SEARCHINDEX",
        state
    });
}
export const updateIndex = (state ) => dispatch => {

    dispatch({
        type: "UPDATE_INDEX",
        state
    });
}
export const selectedUser = (data ) => dispatch => {
    let selecteduser = userService.getSelectedUsers(data);
console.log(selecteduser)
    selecteduser.then(selecteduser => {
        dispatch({
            type: "SELECTED_USER",
            selecteduser
        });
    });
}


// WEBPACK FOOTER //
// ./src/actions/user.js